
import React, { useEffect, useState } from 'react';
import { BankData } from '../../../types';
import { editBankAccount } from '../../../backend-services/bank';
import BankAccountForm from './BankAccountForm';

interface EditProps {
  bankAccount: BankData;
  onEditSuccess: (updatedData: BankData) => void;
  accountIndex: number;
}

export const EditBankAccount: React.FC<EditProps> = ({ bankAccount, onEditSuccess, accountIndex}) => {
  const [formData, setFormData] = useState<BankData>(bankAccount);
  const [bankNameInput, setBankNameInput] = useState<string>(bankAccount.bankName);

  React.useEffect(() => {
    setFormData(bankAccount);
    setBankNameInput(bankAccount.bankName); 
  }, [bankAccount]);

  const handleEditSuccess = (updatedData: BankData) => {
    onEditSuccess(updatedData);
  };

  const handleSubmit = async (data: BankData) => {
    try {
      await editBankAccount(accountIndex, data);
      onEditSuccess(data);
    } catch (error) {
      // Handle error if needed
    }
  };

  
  const [errorMessage, setErrorMessage] = useState<string>('');
  const handleEdit = async (data: BankData) => {
    try {
      setFormData(data);
      setErrorMessage('');
      await handleSubmit(data);
  
      handleEditSuccess(data);
    } catch (error) {
      setFormData(bankAccount);
      setErrorMessage('Error editing bank account');
    }
  };
  
  console.log("initialData:", bankAccount);
  return (
    <>
      <BankAccountForm 
      initialData={formData} 
      edit={true} 
      onSubmit={handleEdit} 
      bankNameInput={bankNameInput} 
      />
      {errorMessage && <p className="error-message">{errorMessage}</p>}
    </>
  );
};
